import { services } from '../services';
var action = "transfer/sale";

export const saletransferService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getReceipt,
    approve,
    denie,
    getTransferSaleReport,
    getDocument

};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getReceipt(id) {
    return services.restApi(`${action}/receipt/${id}`, 'GET');
}

function approve(id) {
    return services.restApi(`${action}/approve/${id}`, 'POST');
}

function denie(id) {
    return services.restApi(`${action}/denie/${id}`, 'POST');
}


// function getTransferSaleReport(param = '', uri='report/transfersale') {
//     return services.restApi(`${uri}${param}`, 'GET'); getDocument
// }

function getTransferSaleReport(param = '', uri='transfer/sale?page=0') {
    return services.restApi(`${uri}${param}`, 'GET');
}

function getDocument(id) {
    return services.restApi(`${action}/document/${id}`, 'GET');
}